import React, { useContext } from 'react';
import { useNavigation } from '@react-navigation/native';
import { Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import Colors from '../../constants/Colors';
import FontStyles from '../../constants/FontStyle';
import StyledIcon from '../StyledIcon';
import { AuthContext } from '../../contexts/auth/Store';

const ChatButton: React.FC = () => {
    const navigation = useNavigation();

    const auth = useContext(AuthContext)
    const chat_instance = auth.getUserData.chat_instance;

    const gotoChatScreen = () => {
        navigation.navigate('Chat')
    }

    const toggleChatWidget = () => {
        try {
            if (chat_instance.chat_window_hidden()) {
                chat_instance.open_chat_window()
            }
            if (chat_instance.chat_window_maximized()) {
                chat_instance.hide_chat_window()
            }
        } catch (e) {
            console.log(e)
        }
    }

    return <>
        {
            Platform.OS === 'android'
                ? <TouchableOpacity style={styles.wrapper} onPress={gotoChatScreen}>
                    <Text style={styles.text}>Chat</Text>
                    <StyledIcon
                        iconName="md-chatbox-ellipses"
                        iconColor={Colors.whiteColor}
                        size={13}
                        iconOnly
                    />
                </TouchableOpacity>
                : <>
                    {
                        chat_instance
                            ? <TouchableOpacity style={styles.wrapper} onPress={toggleChatWidget}>
                                <Text style={styles.text}>Chat</Text>
                                <StyledIcon
                                    iconName="md-chatbox-ellipses"
                                    iconColor={Colors.whiteColor}
                                    size={13}
                                    iconOnly
                                />
                            </TouchableOpacity>
                            : null
                    }
                </>
        }
    </>
}

export default ChatButton

const styles = StyleSheet.create({
    wrapper: {
        flexDirection: 'row',
        flexShrink: 1,
        justifyContent: 'space-between',
        alignItems: 'center',

        paddingHorizontal: 6,
        paddingVertical: 4,
        borderRadius: 100,

        backgroundColor: Colors.midTintColor,
    },
    text: {
        ...FontStyles.size13,
        ...FontStyles.medium,
        ...FontStyles.lh15,
        ...FontStyles.white,

        marginRight: 6,
        marginTop: -2,
    },
    icon: {}
})